import React from 'react';
import { useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import { FlagsProvider } from '@atlaskit/flag';
import Spinner from '@atlaskit/spinner';
import { FireUIAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
import { ProformaIntlProvider } from '@atlassian/proforma-utils/intl-provider';
import { NoticeProvider } from '@atlassian/proforma-utils/show-notice';
import { useFormIndexState, useSelectedFormStoreState } from '../../controllers/form-index';
import lazyMessages from '../../i18n/lazy';
import { FormCard } from './form-card';
import { EmptyFormsLoadingPlaceholder, FormCards, FormCardsContainer, SpinnerBackdrop } from './styled';
export const FormCardIndexInternal = ({
  renderFormUfoExperience,
  onFormSelected,
  onFormSelectedOld,
  linkedFieldNames,
  renderMenu,
  onCancelEdit,
  projectType,
  hideLockedLozenge
}) => {
  const {
    formIndex: forms,
    isIndexLoading,
    selectedFormId
  } = useFormIndexState();
  const {
    selectedFormStore
  } = useSelectedFormStoreState();
  if (forms.length === 0 && isIndexLoading) {
    return /*#__PURE__*/React.createElement(FormCardsContainer, null, /*#__PURE__*/React.createElement(EmptyFormsLoadingPlaceholder, null), /*#__PURE__*/React.createElement(SpinnerBackdrop, null, /*#__PURE__*/React.createElement(Spinner, {
      size: "large"
    })));
  }
  if (forms.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormCardsContainer, null, /*#__PURE__*/React.createElement(FormCards, {
    isIndexLoading: isIndexLoading
  }, forms.map((form, index) => /*#__PURE__*/React.createElement(FormCard, {
    key: form.id,
    form: form,
    formStore: form.id === selectedFormId ? selectedFormStore : undefined,
    ufoExperience: renderFormUfoExperience,
    onFormSelected: onFormSelected,
    onFormSelectedOld: onFormSelectedOld,
    linkedFieldNames: linkedFieldNames,
    renderMenu: renderMenu,
    onCancelEdit: onCancelEdit,
    projectType: projectType,
    hideLockedLozenge: hideLockedLozenge,
    isFirstForm: index === 0
  })), !isIndexLoading && renderFormUfoExperience.markFMP() || null, !isIndexLoading && /*#__PURE__*/React.createElement(FireUIAnalytics, {
    actionSubject: ActionSubject.LIST,
    action: Action.VIEWED,
    actionSubjectId: "formsList",
    attributes: {
      formsCount: forms.length
    }
  })), isIndexLoading && /*#__PURE__*/React.createElement(SpinnerBackdrop, null, /*#__PURE__*/React.createElement(Spinner, {
    size: "large"
  })));
};
export const FormCardIndex = props => {
  const {
    locale
  } = useIntl();
  return /*#__PURE__*/React.createElement(ProformaIntlProvider, {
    messages: lazyMessages,
    locale: locale
  }, /*#__PURE__*/React.createElement(FlagsProvider, null, /*#__PURE__*/React.createElement(NoticeProvider, null, /*#__PURE__*/React.createElement(FormCardIndexInternal, props))));
};